import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store as StoreModel } from '@core/models';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { switchMap, take, catchError, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectStore } from '@store/selectors';
import { Availability } from '@core/models';
import { IResponseSuccess } from '@core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {
  store$: Observable<StoreModel | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.store$ = this.store.select(selectStore);
  }

  getAvailability(localChannelId: string | null): Observable<IResponseSuccess<Availability>> {
    return this.store$.pipe(
      filter(store => !!store),
      take(1),
      switchMap(store => {
        return this.http.get<IResponseSuccess<Availability>>(`${environment.microConfiguraciones}/disponibilidad`,{
          params: {
            localId: store.idLocal,
            localCanalId: localChannelId as string
          },
          headers: {
            authorization: store.apiKey,
          }
        });
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

}